module.exports = __webpack_public_path__ + "static/img/ysxy-banner.805679d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/ysxy-banner.jpg
// module id = p0Qr
// module chunks = 0